<template>
  <div class="FullPeriodIoInfoWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      hide-default-footer
      disable-pagination
      :items="list"
      item-key=""
    />
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("EntryDate"),
          value: "BeginDate",
        },
        {
          text: this.$t("DayName"),
          value: "EnterDayName",
        },
        {
          text: this.$t("EntryTime"),
          value: "BeginTime",
        },
        {
          text: this.$t("ExitTime"),
          value: "EndTime",
        },
        {
          text: this.$t("ExitDate"),
          value: "EndDate",
        },
        {
          text: this.$t("DurationTime"),
          value: "Duration",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style>
</style>